import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import generalLogo from "../assets/img/general/logo-dark.png";
import {
  Autocomplete,
  Avatar,
  CircularProgress,
  Modal,
  Paper,
  TextField,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import {
  clearActiveTab,
  clearFormValues,
  RestfullApiService,
} from "../config/service";
import { debounce } from "lodash";
import { MEDIA_URL } from "../config/url";
import { encryptData } from "../utils/storage";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import "../utils/util.css";
import Swal from "sweetalert2";
import { LightTooltip } from "../utils/Tooltip";
import { removeSpace } from "../utils";

const Header = () => {
  const [searchEvent, setSearchEvent] = useState("");
  const [loading, setLoading] = useState(false);
  const [cityOptions, setCityOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [inputInteracted, setInputInteracted] = useState(false);
  const [isInputVisible, setIsInputVisible] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [selected, setSelected] = useState(null);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const user = useSelector((state) => state.user.userProfile);
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const isVerified =
    (user?.Is_Email_Verified && user?.Is_Mobile_Verified) ||
    (user?.Is_Google_Verified && user?.Is_Mobile_Verified);
  const matchSM = useMediaQuery(theme.breakpoints.down("sm"));

  const handleLogoClick = async (e, path) => {
    e.preventDefault();

    if (location.pathname.includes("event-user-details")) {
      const shouldDelete = await Swal.fire({
        title: "Are you sure you want to go back? Your changes will be lost.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f05736",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes",
      });

      if (shouldDelete.isConfirmed) {
        try {
          clearFormValues();
          navigate(path, { replace: true });
        } catch (err) {
          toast.error("Failed to navigate back");
        }
      }
    } else {
      clearFormValues();
      clearActiveTab();
      navigate(path);
    }
  };
  const handleNavigation = (e) => {
    e.preventDefault();

    if (user && isVerified) {
      handleLogoClick(e, "/dashboard/profile");
    } else {
      navigate("/login");
    }
  };
  async function loadEventList(data) {
    const reqdata = {
      Method_Name: "Golbalfilter",
      Month: data?.Month || "",
      Sport_Id: data?.Sport || "",
      City_Id: data?.City || "",
      Event_Id: "",
      SearchBy: data || "",
    };
    try {
      const result = await RestfullApiService(
        reqdata,
        "participant/event_list"
      );
      if (result) {
        return result;
      }
    } catch (err) {
      console.log(err);
    }
  }

  const customStyles = {
    option: {
      display: "flex",
      alignItems: "center",
      fontFamily: "Montserrat, sans-serif",
      fontSize: "13px",
      fontWeight: 500,
      letterSpacing: "0.02em",
      padding: "6px",
      cursor: "pointer",
      // Default background color
      backgroundColor: "transparent",
      // Hover state
      "&:hover": {
        backgroundColor: "#FEEFEC !important",
      },
      // Focused state
      "&.Mui-focused": {
        backgroundColor: "#FEEFEC !important",
      },
      '&[aria-selected="true"] &.Mui-focused': {
        backgroundColor: "#FEEFEC !important",
      },
    },
    firstOption: {
      display: "flex",
      alignItems: "center",
      fontSize: "13px",
      fontWeight: 500,
      letterSpacing: "0.02em",
      padding: "6px",
    },
    iconContainer: {
      borderRadius: "6px",
      height: "40px",
      width: "55px",
    },
  };
  const CustomOption = (props) => {
    const { option, loading } = props;
    return (
      <div
        // style={isFirstOption ? firstOptionStyle : OptionStyles}
        // style={isFirstOption ? customStyles.firstOption : customStyles.option}
        style={{
          display: "flex",
          alignItems: "center",
          fontSize: "13px",
          fontWeight: 500,
          letterSpacing: "0.02em",
          padding: "6px",
          cursor: "pointer",
          width: "100%",
        }}
      >
        <div
          style={option?.id !== "no-options" ? customStyles.iconContainer : {}}
        >
          {option?.id !== "no-options" ? (
            <img
              src={`${MEDIA_URL}${option?.Image_Path}`}
              // className="rounded-full object-cover border-primary"
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "6px",
                objectFit: "cover",
              }}
              alt="event"
            />
          ) : null}
        </div>
        <span className="label pl-15">
          {option?.id === "no-options"
            ? `${loading ? "Searching" : "No Results Found. Search"} "${
                option?.Display_Name
              }" ${loading ? "" : "?"}`
            : option?.Display_Name}
        </span>
      </div>
    );
  };
  const fetchOptions = useMemo(
    () =>
      debounce(async (data) => {
        if (!data?.trim()) {
          // If data is empty, do not proceed with the API call
          setCityOptions([]);
          setLoading(false);
          return;
        }
        try {
          const response = await loadEventList(data);
          if (response) {
            // let newOptions = [];
            const cities =
              response?.data?.Result?.Table1?.map((dec, id) => ({
                ...dec,
                id: id,
              })) || [];

            setCityOptions(cities);
          }
        } catch (error) {
          console.error("Failed to fetch options:", error);
        } finally {
          setLoading(false);
        }
      }, 200),
    []
  );

  useEffect(() => {
    // !isOpen ||
    // if (!isOpen || inputValue === "") {
    //   console.log("Empty");
    //   // fetchOptions(inputValue);
    //   setCityOptions([]);
    // } else {
    setLoading(true);
    fetchOptions(inputValue);
    // }
  }, [fetchOptions, inputValue, isOpen]);

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div class="langMenu__content bg-white rounded-8 px-40 py-40 lg:px-20 lg:py-20">
          <div class="px-10 py-10 sm:px-15 sm:py-15 text-center">
            <p className="text-primary fw-600 text-18">We are getting ready.</p>
            <p className="text-13 fw-500 mb-20">
              In the meanwhile, please contact to list your event.
            </p>
            <p className="text-12 fw-500">marketing@fitizenindia.com</p>
            <p className="text-12 fw-500">supportevents@fitizenindia.com</p>
          </div>
        </div>
      </Modal>
      <header
        className="header js-header bg-white"
        data-x="header"
        data-x-toggle="is-menu-opened"
      >
        <div
          data-anim=""
          className="header__container header__container-1500 mx-auto px-70 sm:px-20"
        >
          <div className="row justify-between items-center">
            <div className="col-auto">
              <div className="d-flex items-center">
                {/* <Link to="/" className="header-logo"> */}
                <a
                  href="/"
                  className="header-logo"
                  onClick={(e) => {
                    setIsInputVisible(false);
                    setShowMobileMenu(false);
                    handleLogoClick(e, "/");
                  }}
                >
                  <img src={generalLogo} alt="logo icon" />
                  <img src={generalLogo} alt="logo icon" />
                </a>
                {/* </Link> */}
              </div>
            </div>
            {/* <!-- <div className="col-auto d-none lg:d-block">
                     <div className="d-flex items-center">
                       <button data-x-click="dashboard">
                         <i className="icon-menu-2 text-20"></i>
                       </button>
                     </div>
                     </div> --> */}
            <div className="col-auto">
              <div className="d-flex items-center lg:d-none">
                <Autocomplete
                  className="custom-search"
                  id="asynchronous-demo"
                  // open={isOpen}
                  open={isOpen && (cityOptions.length > 0 || inputInteracted)}
                  // open={isOpen && (!cityOptions.length > 0 || inputInteracted)}
                  onOpen={() => {
                    setIsOpen(true);
                  }}
                  onClose={() => {
                    setIsOpen(false);
                  }}
                  // isOptionEqualToValue={(option, value) =>
                  //   option.Display_Name === value.Display_Name
                  // }
                  // getOptionLabel={(option) => option.Display_Name}
                  getOptionLabel={(option) =>
                    option["Display_Name"] ? option["Display_Name"] : option
                  }
                  value={selected?.Display_Name}
                  options={cityOptions}
                  loading={loading}
                  onInputChange={(e, newInput, reason) => {
                    // console.log(e, reason);
                    // console.log(cityOptions);

                    if (reason === "clear") {
                      setInputValue("");
                    }
                    if (e?.type === "change") {
                      console.log(e, newInput);
                      setInputValue(newInput);
                      if (!inputInteracted) {
                        setInputInteracted(true);
                      }
                    }
                  }}
                  onChange={(e, newValue, reason) => {
                    if (reason === "createOption" && e.type === "keydown") {
                      // localStorage.setItem(
                      //   "navigateSelectedCategory",
                      //   cityOptions[0]?.Display_Name
                      // );
                      setInputValue(newValue);
                      console.log(e, newValue, reason);
                      console.log("createOption");
                      if (location.pathname === "/event/list") {
                        // Refresh the page if already on /event/list
                        window.location.reload();
                      } else {
                        // Navigate to /event/list if not already there
                        navigate("/event/list");
                      }
                      return;
                    }
                    if (newValue?.Result_Type === "EventType") {
                      setSelected(newValue);
                      setInputValue(newValue?.Display_Name);
                      localStorage.setItem(
                        "navigateSelectedCategory",
                        newValue?.Display_Name
                      );

                      if (location.pathname === "/event/list") {
                        window.location.reload();
                      } else {
                        navigate("/event/list");
                      }
                    }
                    if (newValue?.Result_Type === "City") {
                      console.log(window.location.href);
                      setSelected(newValue);
                      setInputValue(newValue?.Display_Name);
                      localStorage.setItem(
                        "navigateSelectedCity",
                        newValue?.Display_Name
                      );

                      if (location.pathname === "/event/list") {
                        window.location.reload();
                      } else {
                        navigate("/event/list");
                      }
                    }
                    if (newValue?.Result_Type === "Event") {
                      console.log(location.pathname);
                      setSelected(newValue);
                      setInputValue(newValue?.Display_Name);
                      const encryptedParam = encryptData(newValue?.Result_Id);

                      navigate(
                        `/event-details/${removeSpace(
                          newValue?.Display_Name
                        )}/${encryptedParam}`
                      );
                    }
                    if (!newValue?.Result_Type && reason !== "clear") {
                      setSelected(newValue);
                      setInputValue(newValue?.Display_Name);
                      localStorage.setItem(
                        "navigateSelectedCity",
                        newValue?.Display_Name
                      );

                      toast.error("No Results Found");
                      if (location.pathname === "/event/list") {
                        window.location.reload();
                      } else {
                        navigate("/event/list");
                      }
                    }
                  }}
                  // filterOptions={(x) => x}
                  filterOptions={(options, state) => {
                    if (options.length === 0 && inputValue.trim() !== "") {
                      // setCityOptions([
                      //   {
                      //     Display_Name: `${inputValue}`,
                      //     value: "",
                      //     id: "no-options",
                      //   },
                      // ]);
                      return [
                        {
                          Display_Name: `${inputValue}`,
                          value: "",
                          id: "no-options",
                        },
                      ];
                    } else {
                      console.log(options);
                      if (
                        options[0]?.id === "no-options" &&
                        !options[0].Display_Name
                      ) {
                        console.log("No options");
                        return [];
                      }
                      console.log(options);
                      return options;
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Search by Events, Location, Activities etc..."
                      sx={customStyles.inputRoot}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {loading ? (
                              <CircularProgress
                                style={{ color: "#f05736", marginRight: "5px" }}
                                size={20}
                              />
                            ) : null}

                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                  renderOption={(props, option, { selected, inputValue }) => (
                    <li {...props} style={customStyles.option} id={option.id}>
                      <CustomOption
                        option={option}
                        isFocused={props["aria-selected"]}
                        isSelected={selected}
                        loading={loading}
                      />
                    </li>
                  )}
                  PaperComponent={(props) => (
                    <Paper {...props} style={customStyles.paper} />
                  )}
                  // noOptionsText={
                  //   inputInteracted && cityOptions.length === 0
                  //     ? "No options"
                  //     : ""
                  // }
                  forcePopupIcon={false}
                  freeSolo
                />
              </div>
            </div>
            <div className="col-auto">
              <div className="d-flex items-center">
                <div
                  className={`header-menu${
                    showMobileMenu ? " is-menu-active" : ""
                  }`}
                  // data-x="mobile-menu"
                  // data-x-toggle="is-menu-active"
                >
                  <div className="mobile-overlay"></div>

                  <div className="header-menu__content">
                    <div
                      onClick={() => {
                        setShowMobileMenu(false);
                      }}
                      className="absolute menu-cancel d-none lg:d-block"
                      style={{ right: "15px", zIndex: 2 }}
                    >
                      <i className="fas fa-times text-18 pointer"></i>
                    </div>
                    <div className="mobile-bg js-mobile-bg"></div>
                    <div className="menu js-navList">
                      <ul className="menu__nav text-dark-1 -is-active">
                        <li className="">
                          <button
                            onClick={(e) => {
                              setShowMobileMenu(false);
                              handleLogoClick(e, "/event/list");
                            }}
                          >
                            <span className="text-14 fw-700 text-dark-1 button rounded-22 pr-20 py-10">
                              Events
                            </span>
                          </button>
                        </li>
                        {!isVerified ? (
                          <li className="">
                            <button
                              onClick={() => {
                                setShowMobileMenu(false);
                                handleOpen();
                              }}
                            >
                              <span className="text-14 text-dark-1 fw-700 button -primary-1 rounded-22 px-20 py-10 d-flex items-center lg:px-0">
                                List an Event
                                {!matchSM ? (
                                  <i className="fas fa-plus text-10 ml-10"></i>
                                ) : (
                                  <></>
                                )}
                              </span>
                            </button>
                          </li>
                        ) : (
                          <></>
                        )}
                      </ul>
                    </div>
                    <div className="mobile-footer px-20 py-20 border-top-light js-mobile-footer"></div>
                  </div>
                </div>
                {!isLoggedIn || !isVerified ? (
                  <div className="d-flex items-center ml-10 is-menu-opened-hide lg:d-none">
                    <Link to="/login">
                      <button
                        className="button -primary-1 h-40 px-20 rounded-100 border-dark-1 text-15 text-dark-1"
                        data-x-click="login"
                      >
                        <i className="far fa-user text-14 mr-10"></i>
                        Login
                      </button>
                    </Link>
                  </div>
                ) : (
                  !isMobile && (
                    <>
                      <LightTooltip
                        title="View Profile"
                        placement="bottom"
                        enterTouchDelay={20}
                        arrow
                      >
                        <Avatar
                          onClick={(e) => {
                            handleLogoClick(e, "/dashboard/booking");
                          }}
                          sx={{
                            bgcolor: "#EE5636",
                            marginRight: "10px",
                            cursor: "pointer",
                          }}
                        >
                          {user?.First_Name?.slice(0, 1)}
                        </Avatar>
                      </LightTooltip>
                      {user?.First_Name && (
                        <span className="fw-600 text-14">
                          Hi, {user?.First_Name?.split(" ")[0]}
                        </span>
                      )}
                    </>
                  )
                )}

                {/* {/ <!-- mobile menu --> /} */}
                <div
                  className={`d-none lg:d-flex x-gap-20 items-center${
                    showMobileMenu ? " text-dark-1" : ""
                  }`}
                  data-x="header-mobile-icons"
                  data-x-toggle="text-dark-1"
                >
                  <div className="search-icon">
                    <button
                      className="d-flex items-center fas fa-search text-dark-1 text-18"
                      onClick={() => {
                        setShowMobileMenu(false);
                        setIsInputVisible(!isInputVisible);
                      }}
                    ></button>
                  </div>
                  <div
                    id="search-inputmob"
                    className="search-inputmob"
                    style={{
                      display: isInputVisible ? "flex" : "none",
                      justifyContent: "center",
                    }}
                  >
                    <div>
                      <Autocomplete
                        className="mobile-custom-search"
                        id="asynchronous-demo"
                        open={
                          isOpen && (cityOptions.length > 0 || inputInteracted)
                        }
                        onOpen={() => {
                          setIsOpen(true);
                        }}
                        onClose={() => {
                          setIsOpen(false);
                        }}
                        getOptionLabel={(option) =>
                          option["Display_Name"]
                            ? option["Display_Name"]
                            : option
                        }
                        value={selected?.Display_Name}
                        options={cityOptions}
                        loading={loading}
                        onInputChange={(e, newInput, reason) => {
                          if (reason === "clear") {
                            setInputValue("");
                          }
                          if (e?.type === "change") {
                            console.log(e, newInput);
                            setInputValue(newInput);
                            if (!inputInteracted) {
                              setInputInteracted(true);
                            }
                          }
                        }}
                        onChange={(e, newValue, reason) => {
                          if (
                            reason === "createOption" &&
                            e.type === "keydown"
                          ) {
                            setInputValue(newValue);
                            console.log(e, newValue, reason);
                            console.log("createOption");
                            if (location.pathname === "/event/list") {
                              window.location.reload();
                            } else {
                              navigate("/event/list");
                            }
                            return;
                          }
                          if (newValue?.Result_Type === "EventType") {
                            setSelected(newValue);
                            setInputValue(newValue?.Display_Name);
                            localStorage.setItem(
                              "navigateSelectedCategory",
                              newValue?.Display_Name
                            );

                            if (location.pathname === "/event/list") {
                              window.location.reload();
                            } else {
                              navigate("/event/list");
                            }
                          }
                          if (newValue?.Result_Type === "City") {
                            console.log(window.location.href);
                            setSelected(newValue);
                            setInputValue(newValue?.Display_Name);
                            localStorage.setItem(
                              "navigateSelectedCity",
                              newValue?.Display_Name
                            );

                            if (location.pathname === "/event/list") {
                              window.location.reload();
                            } else {
                              navigate("/event/list");
                            }
                          }
                          if (newValue?.Result_Type === "Event") {
                            console.log(location.pathname);
                            setSelected(newValue);
                            setInputValue(newValue?.Display_Name);
                            const encryptedParam = encryptData(
                              newValue?.Result_Id
                            );

                            navigate(
                              `/event-details/${removeSpace(
                                newValue?.Display_Name
                              )}/${encryptedParam}`
                            );
                          }
                          if (!newValue?.Result_Type && reason !== "clear") {
                            setSelected(newValue);
                            setInputValue(newValue?.Display_Name);
                            localStorage.setItem(
                              "navigateSelectedCity",
                              newValue?.Display_Name
                            );

                            toast.error("No Results Found");
                            if (location.pathname === "/event/list") {
                              window.location.reload();
                            } else {
                              navigate("/event/list");
                            }
                          }
                        }}
                        filterOptions={(options, state) => {
                          if (
                            options.length === 0 &&
                            inputValue.trim() !== ""
                          ) {
                            return [
                              {
                                Display_Name: `${inputValue}`,
                                value: "",
                                id: "no-options",
                              },
                            ];
                          } else {
                            console.log(options);
                            if (
                              options[0]?.id === "no-options" &&
                              !options[0].Display_Name
                            ) {
                              console.log("No options");
                              return [];
                            }
                            console.log(options);
                            return options;
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            placeholder="Search by Events, Location, Activities etc..."
                            sx={customStyles.inputRoot}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {loading ? (
                                    <CircularProgress
                                      style={{
                                        color: "#f05736",
                                        marginRight: "5px",
                                      }}
                                      size={20}
                                    />
                                  ) : null}

                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                        renderOption={(
                          props,
                          option,
                          { selected, inputValue }
                        ) => (
                          <li
                            {...props}
                            style={customStyles.option}
                            id={option.id}
                          >
                            <CustomOption
                              option={option}
                              isFocused={props["aria-selected"]}
                              isSelected={selected}
                              loading={loading}
                            />
                          </li>
                        )}
                        PaperComponent={(props) => (
                          <Paper {...props} style={customStyles.paper} />
                        )}
                        forcePopupIcon={false}
                        freeSolo
                      />
                    </div>
                    {/* <div className="searchMenu-loc lg:py-20 lg:px-0 js-form-dd js-liverSearch">
                      <div
                        className="single-field relative d-flex items-center search-bar"
                        data-x-dd-click="searchMenu-loc"
                      >
                        <input
                          className="border-light text-dark-1 search-input"
                          type="text"
                          name="search-input"
                          placeholder="Events, attraction, activities, etc..."
                          required
                        />
                        <button className="absolute d-flex items-center h-full single-field bg-primary text-dark-1 input-btn">
                          <i className="fas fa-search text-20 px-15"></i>
                        </button>
                      </div>
                    </div> */}
                  </div>
                  <div>
                    {!user || !isVerified ? (
                      <button
                        onClick={() => {
                          setIsInputVisible(false);
                          setShowMobileMenu(false);
                          navigate("/login");
                        }}
                        className="d-flex items-center text-dark-1 text-18"
                      >
                        <i className="fas fa-user text-18 mr-10"></i>
                        Login
                      </button>
                    ) : (
                      <button
                        className="d-flex items-center text-dark-1 text-18"
                        onClick={handleNavigation}
                      >
                        <i className="fas fa-user"></i>
                      </button>
                    )}
                  </div>
                  <div>
                    <button
                      className="d-flex items-center fas fa-ellipsis-v text-dark-1 text-18"
                      onClick={() => {
                        setIsInputVisible(false);
                        setShowMobileMenu(!showMobileMenu);
                      }}
                    ></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;

// {
/* <InputAdornment position="end">
                              <div
                                className="absolute d-flex items-center justify-center h-full single-field bg-primary text-white input-btn"
                                style={{ cursor: "pointer" }}
                                onMouseDown={(e) => e.preventDefault()}
                              >
                                <i
                                  className="fas fa-search text-14 px-15"
                                  onClick={() => {
                                    console.log(selected);
                                    // const searchData = {
                                    //   search: selected?.label ?? "",
                                    // };
                                    // navigate("/event/list", {
                                    //   state: searchData,
                                    // });
                                  }}
                                ></i>
                              </div>
                            </InputAdornment> */
// }
// const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
//   "& .MuiOutlinedInput-root": {
//     position: "relative",
//     width: "370px",
//     borderRadius: "32px",
//     paddingLeft: "12px",
//     paddingTop: "4px",
//     paddingBottom: "4px",
//     fontFamily: "Montserrat, sans-serif",
//     fontSize: "15px",
//     letterSpacing: "0.02em",
//     transition: "all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1)",
//     fontWeight: 500,
//     color: "#111111",
//     "& fieldset": {
//       borderColor: "gray",
//     },
//     "&:hover fieldset": {
//       borderColor: "#f05736",
//     },
//     "&.Mui-focused fieldset": {
//       borderColor: "#f05736",
//     },
//   },
//   "& .MuiInputBase-input": {
//     fontSize: "13px",
//     fontWeight: 500,
//     letterSpacing: "0.02em",
//   },
//   "& .MuiAutocomplete-option": {
//     ...customStyles.option,
//   },
// }));
// useEffect(() => {
//   // debugger;
//   if (inputValue) {
//     console.log("Open");
//     // setIsOpen(true); // Open the dropdown when input changes
//     setLoading(true);
//     fetchOptions(inputValue);
//   }
//   // else {
//   //   console.log("Close");
//   //   setCityOptions([]);
//   //   setIsOpen(false); // Close the dropdown if input is empty
//   // }
// }, [inputValue, fetchOptions]);
// useEffect(() => {
//   if (inputValue && isTyping) {
//     fetchOptions(inputValue);
//   }
// }, [inputValue, fetchOptions, isTyping]);
// }, [inputValue, fetchOptions, isTyping]);
// useEffect(() => {
//   let active = true;
//   console.log(inputValue);
//   if (inputValue === "") {
//     setCityOptions([]);
//     return;
//   }

//   fetchOptions(inputValue);

//   return () => {
//     active = false;
//   };
// }, [inputValue, fetchOptions]);
// useEffect(() => {
//   console.log("Search again");
//   if (inputValue) {
//     const filtered = cityOptions.filter((option) =>
//       option.label.toLowerCase().includes(inputValue.toLowerCase())
//     );
//     // setFilteredOptions(filtered);
//     // setIsOpen(true);
//   } else {
//     // setFilteredOptions([]); // Reset to all options
//   }
// }, [inputValue]);
// const options = [
//   { value: "Mumbai", label: "Mumbai", id: 0 },
//   { value: "Pune", label: "Pune", id: 1 },
//   { value: "Delhi", label: "Delhi", id: 2 },
// ];
// sx={
// {
// "& + .MuiAutocomplete-popper .MuiAutocomplete-option": {
//   backgroundColor: "red",
// },
// "& + .MuiAutocomplete-popper .MuiAutocomplete-option:hover":
//   {
//     // 👇 Customize the hover bg color here
//     backgroundColor: "hotpink",
//   },
// // 👇 Optional: keep this one to customize the selected item when hovered
// "& + .MuiAutocomplete-popper .MuiAutocomplete-option[aria-selected='true']:hover":
//   {
//     backgroundColor: "hotpink",
//   },
// }
// }
// const customStyles = {
//   inputRoot: {
//     "& .MuiOutlinedInput-root": {
//       position: "relative",
//       width: "370px",
//       borderRadius: "32px",
//       paddingLeft: "12px",
//       paddingTop: "3px",
//       paddingBottom: "3px",
//       fontSize: "15px",
//       letterSpacing: "0.02em",
//       transition: "all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1)",
//       fontWeight: 500,
//       color: "#111111",
//       "& fieldset": {
//         borderColor: "gray",
//       },
//       "&:hover fieldset": {
//         borderColor: "black",
//       },
//       "&.Mui-focused fieldset": {
//         borderColor: "black",
//       },
//     },
//     "& .MuiInputBase-input": {
//       fontSize: "13px",
//       fontWeight: 500,
//       letterSpacing: "0.02em",
//     },
//   },
//   option: {
//     borderBottom: "1px solid #ccc",
//     padding: "10px",
//     fontSize: "13px",
//     fontWeight: 500,
//     letterSpacing: "0.02em",
//     backgroundColor: "transparent",
//     '&[aria-selected="true"]': {
//       backgroundColor: "#f0f0f0",
//       color: "#fff",
//     },
//     '&[data-focus="true"]': {
//       backgroundColor: "#f0f0f0",
//       color: "#000",
//     },
//   },
//   paper: {
//     borderRadius: "8px",
//   },
//   clearIndicator: {
//     position: "absolute",
//     right: "45px",
//     cursor: "pointer",
//     color: "inherit",
//     fontWeight: 500,
//     "&:hover": {
//       color: "#f05736",
//     },
//   },
//   dropdownIndicator: {
//     padding: 0,
//     cursor: "pointer",
//   },
// };
// paper: {
//   borderRadius: "8px",
//   maxHeight: "200px", // Set a max height to enable scrolling
//   overflowY: "auto", // Enable vertical scrolling
//   "&::-webkit-scrollbar": {
//     width: "8px", // Width of the scrollbar
//   },
//   "&::-webkit-scrollbar-thumb": {
//     backgroundColor: "#888", // Color of the scrollbar thumb
//     borderRadius: "8px",
//   },
//   "&::-webkit-scrollbar-thumb:hover": {
//     backgroundColor: "#555", // Color of the scrollbar thumb on hover
//   },
//   "&::-webkit-scrollbar-track": {
//     backgroundColor: "#f1f1f1", // Color of the scrollbar track
//   },
// },
